/* eslint-disable import/prefer-default-export */

export const routePropDefault = {
  withHeaderAlt: false,
  containerAlt: false,
  scrollable: false,
};

// Specify the most specific route first
// Ex: /referral/magic-carpet then /referral
export const routeProps = [
  {
    url: '/referral/magic-carpet',
    withHeaderAlt: true,
    className: 'p-0',
  },
  {
    url: '/referral/check-reward',
    withHeaderAlt: true,
  },
  {
    url: '/referral',
    withHeaderAlt: true,
  },
  {
    url: '/account-detail',
    withHeaderAlt: true,
  },
  {
    url: '/rdn',
    withHeaderAlt: true,
    scrollable: true,
  },
  {
    url: '/faq-detail',
    withHeaderAlt: true,
    className: 'p-0',
  },
  {
    url: '/faq',
    withHeaderAlt: true,
    className: 'p-0',
  },
  {
    url: '/simulator',
    withHeaderAlt: true,
  },
  {
    url: '/glossary',
    withHeaderAlt: true,
  },
  {
    url: '/margin-trading-activation',
    withHeaderAlt: true,
    scrollable: true,
  },
  {
    url: '/margin-trading-status',
    withHeaderAlt: true,
    scrollable: true,
  },
  {
    url: '/margin-trading-onboarding',
    withHeaderAlt: true,
    scrollable: true,
  },
  {
    url: '/margin-trading-onboarding-tnc',
    withHeaderAlt: true,
    scrollable: true,
  },
  {
    url: '/margin-trading-onboarding-education',
    withHeaderAlt: true,
  },
  {
    url: '/margin-trading',
    withHeaderAlt: true,
    scrollable: true,
  },
  {
    url: '/day-trading',
    withHeaderAlt: true,
    scrollable: true,
  },
  {
    url: '/kyc-renewal-data',
    withHeaderAlt: false,
    scrollable: true,
  },
];
